import { TResponse } from '../basis/types/tresponse';

// 判断响应的CODE
export const isSuccessCode = (code?: TResponse.Code) => code === TResponse.SUCCESS_CODE;

// 判断license逻辑是否到期
export const isLicenseExpire = (code?: TResponse.Code) => code === TResponse.CODE_601;
